module.exports = __webpack_public_path__ + "static/media/slim-tile-icon.210f76e6.svg";